/* eslint-disable import/prefer-default-export */
export const getUserInSession = () => {
  const userData = sessionStorage.getItem('user');
  return userData ? JSON.parse(userData) : undefined;
};
